export function workstationAccountScope() {
  try { const account = JSON.parse(localStorage.getItem('kioskAccount') || 'null'); return String(account?.tenantAccountId || account?.parentAccountId || account?.id || ''); } catch { return ''; }
}
const bindingKey = account => `berestoWorkstation:account:${encodeURIComponent(account)}`;
export function readWorkstationBinding(account = workstationAccountScope()) {
  if (!account) return null;
  try {
    const value = JSON.parse(localStorage.getItem(bindingKey(account)) || 'null');
    return value?.account === account && Number.isSafeInteger(value?.deviceId) && value.deviceId > 0 && typeof value.token === 'string' && value.token ? value : null;
  } catch { return null; }
}
export function hasUnresolvedWorkstationWork() {
  // Unknown legacy/profile ownership fails closed. Never migrate a queue on association.
  for (let index = 0; index < localStorage.length; index += 1) {
    const key = localStorage.key(index);
    if (!/^(berestoTerminalPayment|berestoTerminalOrderDraft|becaisseOfflineQueue|becaisseOfflineConflicts|kds_offline_queue_v1)(:account:|$)/.test(key || '')) continue;
    try { const value = JSON.parse(localStorage.getItem(key)); if (Array.isArray(value) ? value.length : value) return true; } catch { return true; }
  }
  return false;
}
export function saveWorkstationBinding(payload, account = workstationAccountScope()) {
  if (!account || account !== workstationAccountScope()) throw new Error('Compte modifié : rechargez avant association.');
  if (!Number.isSafeInteger(payload?.device?.id) || payload.device.id <= 0 || typeof payload.token !== 'string' || !payload.token) throw new Error('Association du poste invalide.');
  localStorage.setItem(bindingKey(account), JSON.stringify({ account, deviceId: payload.device.id, token: payload.token }));
}
export function operationalScope() {
  let profile = '';
  try { profile = String(JSON.parse(localStorage.getItem('kioskAccount') || 'null')?.id || ''); } catch { return ''; }
  const binding = readWorkstationBinding();
  return binding ? `${profile}:device:${binding.deviceId}` : profile;
}
